<template>
  <div class="menu_container">
    <div class="headLine">
      <img src="./leftAngle.png" alt="返回首页" @click="backIndex" />
      我的工单
    </div>
    <!-- 菜单容器 -->
    <div class="menuBox">
      <div class="boxList box01" @click="mycreate()">
        <img src="./img/myCreate.png" alt="我创建的">
        <p>我创建的</p>
      </div>
      <div class="boxList box02" @click="checkorder()">
        <img src="./img/checkOrder.png" alt="要我检查">
        <p>要我检查</p>
      </div>
      <div class="boxList box03" @click="assignOrder()">
        <img src="./img/assign.png" alt="要我指派">
        <p>要我指派</p>
      </div>
      <div class="boxList box04" @click="receiveOrder()">
        <img src="./img/receiveOrder.png" alt="我接的单">
        <p>我接的单</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return{
      popstateLock: 0,//是否监听物理返回键
    }
  },
  watch:{
    popstateLock(val){
      //在父组件调用方法改变lock的值的时候控制路由的监听来避免preview的close路由调用
      if (val){
        this.addPopstate()
      }else{
        this.removePopstate()
      }
    }
  },
  mounted() {
    this.addPopstate()//在导航栏挂载的时候，对物理返回键进行监听
  },
  destroyed(){
    this.removePopstate()
  },
  methods: {
    addPopstate(){
      //判断是否H5路由
      if (window.history && window.history.pushState) {
        // 往历史记录里面添加一条新的当前页面的url
        history.pushState(null, null, document.URL);
        // 给 popstate 绑定一个方法 监听页面刷新，并绑定getBack()来控制
        window.addEventListener('popstate', this.getBack, false);//false阻止默认事件
      }
    },
    removePopstate(){
      //解除监听
      window.removeEventListener('popstate', this.getBack, false);//false阻止默认事件
    },
    //指挥路由
    getBack() {
      //判断物理返回键是否监听
      if (!this.popstateLock) {
        window.history.pushState(null, null, '#')
      }
    },
    // 我创建的
    mycreate () {
      this.$router.push({ name: 'orderquery', query: {myOrderType: 0} });
    },
    // 要我检查
    checkorder() {
      this.$router.push({ name: 'orderquery', query: {myOrderType: 1} });
    },
    // 要我指派
    assignOrder() {
      this.$router.push({ name: 'orderquery', query: {myOrderType: 2} });
    },
    // 我接的单
    receiveOrder() {
      this.$router.push({ name: 'orderquery', query: {myOrderType: 3} });
    },
    // 返回首页
    backIndex() {
      this.$router.replace({ name: 'assetsPage' })
    }
  }
}
</script>

<style lang="scss" scoped>
.menu_container {
  font-size: 16px;
  position: relative;
  overflow-x: hidden;
  overflow-y: auto;
  .headLine {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    background-color: #fff;
    height: 50px;
    color: #000;
    font-weight: 600;
    text-align: center;
    line-height: 50px;
    z-index: 99;
    border-bottom: 1px #efefef solid;
    img {
      height: 30px;
      margin: 10px 0;
      padding: 0 10px;
      position: absolute;
      left: 0;
      top: 0;
    }
  }
  .menuBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 70px 20px 20px;
    .boxList {
      display: flex;
      flex-direction: column;
      width: 45%;
      height: calc((100vh / 3) - 60px);
      border-radius: 6px;
      text-align: center;
      margin-bottom: 20px;
      position: relative;
      img {
        margin: 20px auto;
        height: 50px;
      }
      p {
        display: block;
        color: #F3F8F3;
        padding: 0;
        margin: 0 0 15px;
        text-align: center;
        font-size: 18px;
        font-weight: 600;
      }
    }
    .box01 {
      background-color: #36AB60;
    }
    .box02 {
      background-color: #E98F36;
    }
    .box03 {
      background-color: #D81E06;
    }
    .box04 {
      background-color: #A4579D;
    }
    .box05 {
      background-color: #1195DB;
    }
    .box06 {
      background-color: #d0c605;
    }
  }
}
</style>
